module.exports = {
    APOLLO_CLIENT:"https://api.thegraph.com/subgraphs/name/shahzeb8285/kitesyncnft"
}